import { Injectable } from '@angular/core';
import { OidcSecurityService, TokenHelperService } from 'angular-auth-oidc-client';
import { User } from 'app/core/models/user';
import { ReplaySubject } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { ALNIdentityAuthUser } from './aln-identity-user';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { DashboardService } from '@app/modules/dashboard/dashboard.service';
import { result } from 'lodash';

interface ProductClient {
    clientName: string,
    clientCode: string,
    clientRole: string,
    roleParametersList: ProductRole | ProductRole[]
}

interface ProductRole {
    roleParametersName: string,
    roleParametersValue: boolean
}

@Injectable({
    providedIn: 'root',
})
export class ALNIdentityAuthService {
    private authorizedSource = new ReplaySubject<boolean>();
    private _isAuthorized: boolean = false;
    private _user: User = new User();
    private _token = '';

    private _authorizing = false;

    authorized$ = this.authorizedSource.asObservable();

    get isAuthorized(): boolean {
        return this._isAuthorized;
    }

    get user(): User {
        if (!this.isAuthorized) {
            this._user = new User();
        }

        return this._user;
    }


    setToken(token: string) {
        this._token = token;
        let userData = this._tokenHelperService.getPayloadFromToken(token, false);
        this.mapUser(userData);
        this._isAuthorized = true;
    }

    constructor(
        public oidcSecurityService: OidcSecurityService,
        private _tokenHelperService: TokenHelperService,
        private authentication: AuthenticationService,
        private dashboardService:DashboardService,
        private router: Router) {
        this.oidcSecurityService.getIsAuthorized().subscribe(
            (isAuthorized: boolean) => {
                this._isAuthorized = isAuthorized;

                if (isAuthorized) {
                    this._authorizing = false;
                    let token = this.oidcSecurityService.getToken();
                    localStorage.setItem('token', token);
                    let userData = this._tokenHelperService.getPayloadFromToken(token, false);
                    this.mapUser(userData);
                } else {
                    this._user = new User();
                }

                this.authorizedSource.next(isAuthorized);
            });
        if (this.oidcSecurityService.moduleSetup) {
            this.doCallbackLogicIfRequired();
        } else {
            this.oidcSecurityService.onModuleSetup.subscribe(() => {
                this.doCallbackLogicIfRequired();
            });
        }


    }

    authorizeOnlyOnce() {
        if (!this._authorizing) {
            this._authorizing = true;
            this.oidcSecurityService.authorize();
        }
    }

    login() {
        this.oidcSecurityService.authorize();
    }

    logout() {
        localStorage.clear();
        sessionStorage.clear();
        this.oidcSecurityService.logoff();
    }

    private doCallbackLogicIfRequired() {
        this.oidcSecurityService.authorizedCallbackWithCode(window.location.toString());
    }

    private mapUser(userData: any) {
        const products = this.parseProducts(userData.products);
        this.validateProducts(products);


        const parseObj = (values) => Array.isArray(values)
            ? values.map(v => JSON.parse(v))
            : [JSON.parse(values)];

        const userInfo = new ALNIdentityAuthUser(userData);
        this._user.userId = userInfo.userId;
        this._user.userName = userInfo.preferred_username;
        this._user.fullName = userInfo.name;
        this._user.fName = userInfo.name;
        this._user.profileImageURL = userInfo.profilePictureUrl.startsWith("https://")
            ? userInfo.profilePictureUrl
            : `${env.stsUrl}${userInfo.profilePictureUrl}`;
        this._user.bearerToken = this.oidcSecurityService.getToken();
        this._user.organizationId = userInfo.organizationId;
        this._user.organisation = userInfo.organizationName;
        this._user.applicationRoles = Array.isArray(userInfo.userRoles)
            ? userInfo.userRoles
            : [userInfo.userRoles];

        this._user.bearerToken = this._token;

        this._user.clients = parseObj(userInfo.products);
        this._user.allClients = parseObj(userInfo.allProducts);
        localStorage.setItem('currentUser', JSON.stringify(this._user));
        sessionStorage.setItem('currentUser', JSON.stringify(this._user));
    //     if(this.authentication.currentUserValue!=null){
    //         if(this.authentication.currentUserValue.clients.filter(c=>c.clientCode=='eFiling')){
    //             var userRoles=this.authentication.currentUserValue.clients.filter(c=>c.clientCode=='eFiling')[0];
    //           var isBillin=  userRoles.roleParametersList[1].roleParametersValue;
    //         var IsAdmintool=  userRoles.roleParametersList[0].roleParametersValue
    //             this.dashboardService.updateRoleMaping(isBillin,IsAdmintool).subscribe(
    //                 result => {
    //                     if (result.isSuccess) {
    //                     var result=result;
    //                 }
    //             })            
    //     }
    //  }

        this.authentication.setupMenu();


    }

    parseProducts(productsData: any | any[]): ProductClient | ProductClient[] {
        if (Array.isArray(productsData)) {
            return productsData.map(p => JSON.parse(p));
        } else {
            return JSON.parse(productsData);
        }
    }

    validateProducts(value: ProductClient | ProductClient[]): void {
        let authorized = false;
        const validProduct = 'EFiling Application'

        if (Array.isArray(value)) {
            const products = value;
            authorized = !!products.find(p => p.clientName === validProduct);
        } else {
            const product = value;
            authorized = product.clientName === validProduct;
        }

        if (!authorized) {
            this.router.navigateByUrl('no-access');
        }

    }
}